<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="bg-primary m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" class="text-white">
            <span class="title dialog-title">{{ data.titulo }}</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon class="text-white">close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-2 pb-0 m-0" fusePerfectScrollbar>
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start">
                {{ data.observaciones }}
            </div>
    </div>
</div>
